<div class="ssl-certificate-grid-name-column__missing-certificate-issuer-icon-wrapper">
    <missing-cert-issuer-icon
        *ngIf="missingCertIssuerName"
        [missingCertIssuerName]="missingCertIssuerName"
    ></missing-cert-issuer-icon>
    <span>{{ certificate.config.name }}</span>
</div>
